'use strict'

const views = require('./views')
const pages = require('./pages')
const spreadsheets = require('./spreadsheets')
const rules = require('./rules')
const schedules = require('./schedules')
const automations = require('./automations')
const workflows = require('./workflows')
const apps = require('./apps')
const screens = require('./screens')
const accounts = require('./accounts')

const TOPICS = Object.assign({}, views, pages, spreadsheets, rules, schedules, automations, workflows, apps, screens, accounts)

function getModalHelp (topic) {

  if (!topic || !TOPICS[topic]) return null

  return TOPICS[topic]
}

function modalHelpTopics () {

  return Object.keys(TOPICS)
}

module.exports = {
  getModalHelp,
  modalHelpTopics
}
